import React from "react";
import { Card, Col, Container, Image, Row } from "react-bootstrap";
import { primaryColor } from "../../../../Constants/Colors";
import workImg from "../../../../Assets/Images/Works/colleagues-having-business-meeting-together.png";
import { HowWeWorkContent } from "../../../../Constants/content";

const HowWeWork = () => {
  
  const renderWorkCard = () => {
    return HowWeWorkContent.map((item, index) => (
      <Card key={index} className=" shadow-sm how-we-work-card">
        <Card.Body>
          <Row>
            <Col
              xs={1} md={2}
              className="d-flex align-items-center justify-content-center"
            >
              <p className=" m-0 card-sequence">
                {item.sequence}
              </p>
            </Col>
            <Col xs={10} xl={9}>
              <Card.Title className="card-title">
                {item.title}
              </Card.Title>
              <Card.Text className="card-description">{item.description}</Card.Text>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    ));
  };
  return (
    <Container className="my-5">
      <div className="d-flex align-items-center mb-2">
        <p className="me-3">How we work</p>
        <div style={{ flex: 1, height: "2px", backgroundColor: "#ccc" }}></div>
      </div>
      <h2 className="mt-2 mb-4 fw-bold" style={{ color: primaryColor }}>
        Our Approach to Your Needs
      </h2>
      <Row className="d-flex flex-column-reverse flex-md-row align-items-center ">
        <Col xs={10} md={5} xl={4} className="mx-auto d-flex justify-content-center align-items-center">
          <Image src={workImg} fluid />
        </Col>
        <Col xs={12} md={7} lg={7} xl={7} className="mx-auto d-flex flex-column justify-content-between mb-3 mb-lg-0">
          {renderWorkCard()}
        </Col>
      </Row>
    </Container>
  );
};

export default HowWeWork;
